import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { updateOffering } from '../api/offerings';
import type { OfferingFormValues } from '../types';
import { notification } from 'antd';

export function useUpdateOffering(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: OfferingFormValues) => {
      if (!id) throw new Error('ID is required to update offering');
      return updateOffering(id, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Offering updated successfully' });
      invalidateListResource(queryClient, 'offerings');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to update offering' });
    },
  });
}
